/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import PropTypes from "prop-types";
import { LinearProgress } from "@mui/material";
import { Help as HelpIcon, QrCode2 as QrCode2Icon } from "@mui/icons-material";
import useTranslation from "next-translate/useTranslation";

import { Card, Box, Button, Typography, Grid } from "@/components/core";
import { AppStoreBadge, AppGalleryStoreBadge, GooglePlayStoreBadge } from "@/components/common";

export function UnlimitedAccountCard({ sx, montlyTransaction, totalLimit }: any) {
  const { t } = useTranslation("bank");

  return (
    <Card
      sx={{
        backgroundColor: "#307BB0",
        width: "30vw",
        borderRadius: 4,
        padding: "2rem",
        display: "flex",
        ...sx,
      }}
    >
      <div style={{ width: "85%", margin: "0.8rem auto" }}>
        <Typography textAlign="center" color="white" fontSize={22}>
          {t("unlimitedAccount.title")}
        </Typography>
        <Typography textAlign="center" color="white">
          {t("unlimitedAccount.description")}
        </Typography>

        <div style={{ marginTop: "20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography color="white">{t("unlimitedAccount.monthlyTransaction")}</Typography>
            <Typography color="white">{montlyTransaction} TL</Typography>
          </div>

          <Box sx={{ marginTop: "10px", color: "white" }}>
            <LinearProgress
              sx={{
                backgroundColor: "transparent",
                border: 1,
                borderColor: "white",
                height: 15,
              }}
              color="inherit"
              variant="determinate"
              value={(montlyTransaction * 100) / totalLimit}
            />
          </Box>

          <Typography marginTop={1} color="white" textAlign="end">
            {t("unlimitedAccount.remainingLimit")} : {totalLimit - montlyTransaction} TL
          </Typography>
          <Typography color="white" textAlign="end">
            {t("unlimitedAccount.totalLimit")} : {totalLimit} TL
          </Typography>
        </div>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "white",
            display: "flex",
            margin: "30px auto",
            padding: "0.5rem 1rem",
          }}
        >
          <Typography color="black" fontSize={18}>
            {t("unlimitedAccount.switchButton")}
          </Typography>
        </Button>

        <Typography textAlign="center" color="white">
          {t("unlimitedAccount.appDescription")}
        </Typography>

        <Grid spacing={2} sx={{ marginTop: 2 }}>
          <Grid.Item xs={4}>
            <AppStoreBadge />
          </Grid.Item>
          <Grid.Item xs={4}>
            <GooglePlayStoreBadge />
          </Grid.Item>
          <Grid.Item xs={4}>
            <AppGalleryStoreBadge />
          </Grid.Item>
        </Grid>

        <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
          <QrCode2Icon />
        </div>
      </div>

      <HelpIcon sx={{ color: "white" }} />
    </Card>
  );
}

UnlimitedAccountCard.propTypes = {
  sx: PropTypes.object,
  montlyTransaction: PropTypes.number.isRequired,
  totalLimit: PropTypes.number.isRequired,
};
